import { parseAsInteger, useQueryState } from "nuqs";

export const useSelectedPsychologistIdParam = () =>
  useQueryState("selectedPsychologistId", parseAsInteger);
